import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-z-add-items',
  templateUrl: './z-add-items.component.html',
  styleUrls: ['./z-add-items.component.scss']
})
export class ZAddItemsComponent implements OnInit {
formData: any = {
category_id: null,
  title: '',
  content: '',
  count: 1,
  reference: '',
  order: 0,
  is_active: true

};
   public arrCoupons: any[] = [];
  public lang : any

    public currentLang : string
errors: any = {}; // store validation errors

  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,private language : LanguageService
  ) {}

    ngOnInit(): void {
                this.currentLang = localStorage.getItem('currentLang')

    this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});

                  this.apisService.categories().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })


    }
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  this.formData.image = file.name; // send only file name ✔
}


    cancel(): void {
      this.router.navigate(['/items']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  this.errors = {}; // reset previous errors

   const payload = {
    category_id: this.formData.category_id,
    title: this.formData.title,
    content: this.formData.content,
    count: this.formData.count,
    reference: this.formData.reference,
    order: this.formData.order,
    is_active: this.formData.is_active
  };


  this.apisService.addItems(payload).subscribe({
   next: () => {
  this.toastr.success(
    this.currentLang === 'ar'
      ? 'تمت الإضافة بنجاح'
      : 'Added successfully'
  );

  this.router.navigate(['/items']);
},

error: () => {
  this.toastr.error(
    this.currentLang === 'ar'
      ? 'حدث خطأ أثناء الإضافة'
      : 'Error adding'
  );
}

  });
}


}